import React from 'react'
import { withPrefix, Link } from 'gatsby'
import { useLinkChecker } from '../services/LinkChecker'

const AElement = ({ href, children, ...otherProps }) => {
  if (href.includes('://')) {
    // Not necessary, but you can't skip React hooks.
    useLinkChecker(href)
    return (
      <a {...otherProps} href={href}>
        {children}
      </a>
    )
  } else {
    // Throw error if the page link is broken.
    const to = unPrefix(href)
    useLinkChecker(to)
    return (
      <Link {...otherProps} to={to}>
        {children}
      </Link>
    )
  }
}

/**
 * Removes the pathPrefix from a URL
 */

function unPrefix(href /*: string */) {
  const prefix = withPrefix('/')

  if (href.startsWith(prefix)) {
    return '/' + href.substr(prefix.length)
  } else {
    return href
  }
}

export default AElement
